import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import Navbar from "../components/Navbar";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { importGuestDraftIfAny } from "../lib/guestFlow";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function startGoogleLogin() {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
    redirectUrl,
  )}`;
}

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();
  const [serverError, setServerError] = useState("");

  const onSubmit = async (values) => {
    setServerError("");
    try {
      await login(values.email, values.password);
      const imported = await importGuestDraftIfAny();
      toast.success(imported ? "Welcome back — draft merged into your profile!" : "Welcome back!");
      const to = imported ? "/profile/edit" : (location.state?.from || "/dashboard");
      navigate(to);
    } catch (e) {
      setServerError(formatApiError(e));
    }
  };

  return (
    <div>
      <Navbar />
      <div className="container py-5" style={{ maxWidth: 520 }}>
        <div className="sb-card" data-testid="login-card">
          <div className="sb-kicker mb-2">Sign in</div>
          <h1 className="h2 mb-4">Welcome back.</h1>

          <form onSubmit={handleSubmit(onSubmit)} noValidate>
            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                autoComplete="email"
                data-testid="login-email"
                {...register("email", { required: "Email is required" })}
              />
              {errors.email && (
                <div className="text-danger small mt-1">{errors.email.message}</div>
              )}
            </div>
            <div className="mb-3">
              <label className="form-label">Password</label>
              <input
                type="password"
                className="form-control"
                autoComplete="current-password"
                data-testid="login-password"
                {...register("password", { required: "Password is required" })}
              />
              {errors.password && (
                <div className="text-danger small mt-1">{errors.password.message}</div>
              )}
            </div>

            {serverError && (
              <div className="alert alert-danger py-2" data-testid="login-error">
                {serverError}
              </div>
            )}

            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={isSubmitting}
              data-testid="login-submit"
            >
              {isSubmitting ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <div className="text-center my-3 text-muted small">or</div>

          <button
            type="button"
            onClick={startGoogleLogin}
            className="btn btn-outline-primary w-100"
            data-testid="login-google"
          >
            Continue with Google
          </button>

          <div className="text-center mt-4 small">
            New here?{" "}
            <Link to="/register" className="sb-link-quiet" data-testid="link-register">
              Create an account
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
